import type { PropsWithChildren } from 'react';
import { ErrorBoundary } from '@/shared/ui';
import { getFaro } from '@/shared/observability';
import { App } from './App';

function ErrorBoundaryError({ error }: { error: unknown }) {
  return (
    <div>
      <p>An unhandled error occurred:</p>
      <blockquote>
        <code>
          {error instanceof Error
            ? error.message
            : typeof error === 'string'
              ? error
              : JSON.stringify(error)}
        </code>
      </blockquote>
    </div>
  );
}

const reportError = (error: unknown): void => {
  getFaro()?.api.pushError(error instanceof Error ? error : new Error(String(error)));
};

export function ReportingErrorBoundary({ children }: PropsWithChildren) {
  return (
    <ErrorBoundary onError={reportError} fallbackRender={({ error }) => <ErrorBoundaryError error={error} />}>
      {children}
    </ErrorBoundary>
  );
}

export function Root() {
  return (
    <ReportingErrorBoundary>
      <App />
    </ReportingErrorBoundary>
  );
}
